import React from 'react';
import { Tag } from 'antd';

const TRIGGER_STYLES = {
    ats:            { color: 'blue', label: 'ATS Trigger' },
    keyword:        { color: 'green', label: 'Keyword Reply' },
    'keyword-fork': { color: 'green', label: 'Keyword Reply' },
    timer:          { color: 'gold', label: 'Timed Delay' },
    date:           { color: 'magenta', label: 'Date-Based' },
    scheduling:     { color: 'purple', label: 'Scheduling' },
    time:           { color: 'purple', label: 'Scheduling' },
    event:          { color: 'purple', label: 'Event' },
    manual:         { color: 'default', label: 'Manual Send' },
    reply:          { color: 'cyan', label: 'Awaits Reply' },
    email:          { color: 'cyan', label: 'Awaits Reply' },
    number:         { color: 'cyan', label: 'Awaits Reply' },
    options:        { color: 'cyan', label: 'Options' },
    cards:          { color: 'cyan', label: 'Options' },
};

const TriggerBadge = ({ type }) => {
    const s = TRIGGER_STYLES[type] || TRIGGER_STYLES.manual;
    return (
        <Tag
            color={s.color}
            style={{ margin: 0, borderRadius: 999, fontSize: 11, fontWeight: 500 }}
        >
            {s.label}
        </Tag>
    );
};

export default TriggerBadge;
